<template>
  <div
    class="settle-accounts-detail"
    v-loading="isLoadPage"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="baseColumns"
            :isQueryPanel="false"
            :rules="baseRules"
            @changeMethod="changeMethod"
            :isDisabledForm="!isCreate"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算行
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsRowTable
            :baseFormData="baseFormData"
            :fetchTableData="settleAccountsRowList"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeEditRowTableHandler"
            @deleteRowDataHandler="deleteRowDataHandler"
            ref="settleAccountsRowTableRef"
            :isCreate="isCreate"
            :defaultSelection="defaultSelection"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="Object.keys(currentSettleAccountRowData).length">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算明细
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsDetailTable
            :baseFormData="baseFormData"
            :fetchTableData="currentSettleAccountDetailList"
            :currentSettleAccountRowData="currentSettleAccountRowData"
            @confirmChooseDetailHandler="confirmChooseDetailHandler"
            :isCreate="isCreate"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="billingInfoData.length">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            开票信息
          </div>
        </template>
        <div class="collapse-content">
          <BillingInfoTable :fetchTableData="billingInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5" v-if="receiveInfoData.length">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            收款信息
          </div>
        </template>
        <div class="collapse-content">
          <ReceiveInfoTable :fetchTableData="receiveInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="!isCreate" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="btn-group">
      <template v-if="isCreate">
        <el-button type="primary" @click="saveOrSubmitHandler(0)">保存</el-button>
        <el-button type="primary" @click="saveOrSubmitHandler(1)">提交审批</el-button>
      </template>
      <template v-if="!isCreate">
        <el-button
          type="primary"
          @click="isCreate = true"
          v-if="!['02', '04', '06'].includes(baseFormData.settlementStatus)"
          >编辑</el-button
        >
        <el-button
          type="primary"
          @click="billingApplicationHandler"
          v-if="!['01', '02', '05', '06'].includes(baseFormData.settlementStatus)"
          >开票申请</el-button
        >
        <el-button
          type="primary"
          @click="lockHandler"
          v-if="!['01', '02', '05', '06'].includes(baseFormData.settlementStatus)"
          >结算锁定</el-button
        >
        <el-button
          type="primary"
          @click="isCreate = true"
          v-if="!['01', '02', '04', '05'].includes(baseFormData.settlementStatus)"
          >调整</el-button
        >
        <el-button
          type="primary"
          @click="withdrawHandler"
          v-if="baseFormData.settlementStatus == '04'"
          >撤回</el-button
        >

        <el-button
          type="primary"
          @click="closeHandler"
          v-if="!['01', '02', '04', '05', '06'].includes(baseFormData.settlementStatus)"
          >关闭</el-button
        >
        <el-button
          type="primary"
          @click="printHandler"
          v-if="!['01', '02', '05', '06'].includes(baseFormData.settlementStatus)"
          >打印</el-button
        >
      </template>
    </div>
    <Print ref="easyPrint">
      <PrintDemo :content="content"></PrintDemo>
    </Print>
    <PrintDialog ref="printDialogRef" @printHandler="detailPrintHandler"></PrintDialog>
  </div>
</template>

<script>
  import SettleAccountsRowTable from './components/SettleAccountsRowTable/index.vue';
  import SettleAccountsDetailTable from './components/SettleAccountsDetailTable/index.vue';
  import SuperviseContractForm from './components/SuperviseContractForm/index.js';
  import superviseContractAPI from '@/api/receivablesAndPayables/superviseContract.js';
  import BillingInfoTable from './components/BillingInfoTable/index.vue';
  import ReceiveInfoTable from './components/ReceiveInfoTable/index.vue';
  import { mapNumToString, formatDate } from '@/utils';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import Print from '@/components/Print';
  import PrintDemo from '@/components/Print/printDemo';
  import PrintDialog from '../../../../components/PrintDialog.vue';
  export default {
    name: 'superviseContractDetail',
    mixins: [SuperviseContractForm],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        isLoadPage: false,
        isCreate: true,
        isDetail: true,
        attachments: [],
        currentSettleAccountDetailList: [], //明细表格数据
        currentSettleAccountRowData: {}, // 当前选中结算行的数据
        settleAccountsRowList: [], //全部的行数据
        billingInfoData: [], //根据结算单号查询出来的开票信息
        receiveInfoData: [], //根据结算单号查询出来的收款信息
        content: '',
        defaultSelection: null,
      };
    },
    mounted() {
      console.log('dictListMap?.settlementStatus', this.dictListMap?.settlementStatus);
      this.isCreate = this.$route.query.status == 'create';
      this.isDetail = this.$route.query.status == 'detail';
      // 获取传递过来的id数组
      if (['create'].includes(this.$route.query?.status)) {
        let selectIdList = this.$route.query?.id;
        if (selectIdList) {
          selectIdList = Array.isArray(selectIdList) ? selectIdList : [selectIdList];
          if (selectIdList.length) {
            this.getDetailDataById(selectIdList);
          }
        }
      }
      // 列表进来的时候
      if (['detail', 'edit'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.id);
      }
    },
    methods: {
      // 切换合同号的时候清空数据
      clearAccountTableData() {
        this.currentSettleAccountDetailList = []; //明细表格数据
        this.currentSettleAccountRowData = {}; // 当前选中结算行的数据
        this.settleAccountsRowList = []; //全部的行数据
      },
      // 获取开票信息
      async _getInvoiceTableListData(receiveNo) {
        if (!receiveNo) return;
        const postData = { settlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_INVOICING_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.billingInfoData = data.data || [];
        } else {
          // this.$message.error('获取数据失败');
        }
        console.log(data, '开票信息');
      },
      // 获取收款信息
      async _getCollectTableListData(receiveNo) {
        if (!receiveNo) return;
        const postData = { settlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_COLLECTION_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.receiveInfoData = data.data || [];
        } else {
          // this.$message.error('获取数据失败');
        }
        console.log(data, '收款信息');
      },
      // 根据id来查下数据 --> 应收列表调用接口
      async _getDetailDataById(id) {
        if (!id) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.GET_RECEIVABLE_SETTLEMENT_DETAIL_BY_ID}/${id}`
        );
        this.loading.endLoading();
        console.log(data, 'data');
        if (data.code == 0) {
          this.baseFormData = {
            ...mapNumToString(data.data),
            settlementNo: data.data.receivableSettlementNo,
            printFlag: data.data.printFlag == '0' ? false : true,
          };
          // this.$nextTick(() => {
          //   this.$refs.baseInfoFormRef.clearValidate();
          // });
          this._getInvoiceTableListData(this.baseFormData.settlementNo);
          this._getCollectTableListData(this.baseFormData.settlementNo);
          this.settleAccountsRowList = data.data.lines.map((item) => {
            return {
              ...item,
              createMethod: item.createMethod == '01' ? '系统' : '手动',
            };
          });
          this.attachments = data.data?.attachments || [];
          // 单独处理如果是有结算行的时候显示明细行出来(第一行)
          if (this.settleAccountsRowList.length) {
            this.currentSettleAccountRowData = this.defaultSelection =
              this.settleAccountsRowList[0];
            this.currentSettleAccountDetailList = this.settleAccountsRowList[0]?.lineDetails || [];
          }
        } else {
          this.$message.warning('查询数据失败');
        }
      },
      // 根据id获取详情数据-->创建的时候
      async getDetailDataById(selectIdList) {
        this.loading.startLoading();
        const { data } = await this.$axios.post(`${superviseContractAPI.GET_DETAIL_BY_IDS}`, {
          ids: selectIdList,
        });
        this.isLoadPage = false;
        this.loading.endLoading();
        console.log(data, '???查询数据');
        if (data.code == 0) {
          this.currentSettleAccountDetailList = data.data.map((item) => {
            return {
              ...item,
              settlementQuantity: item.statementQuantity,
              createMethod: item.createMethod == '01' ? '系统' : '手动',
            };
          });
          // 分类计算计算行
          this.computedSettleAccountsRowByExpenseTypeName(
            data.data.map((item) => {
              return {
                ...item,
                settlementQuantity: item.statementQuantity,
              };
            })
          );
          // 填充到上面表单(取第一条数据)
          console.log('获取费用清单数据', data.data[0]);
          this.baseFormData = {
            ...mapNumToString(data.data[0]),
            // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）TODO 表单中有就用表单的
            ...this.computedTotalAmount(data.data),
            // 如果有值就用返回的,没有就用默认的
            settlementIssueStatus: '02',
            settlementType: '2',
            settlementCompanyNo: data.data[0]?.businessCompanyNo || this.userInfo.companyCode,
            settlementCompanyName: data.data[0]?.businessCompanyName || this.userInfo.companyName,
            settlementDepartmentNo:
              data.data[0]?.businessDepartmentCode || this.userInfo.departmentCode,
            settlementDepartmentName:
              data.data[0]?.businessDepartmentName || this.userInfo.departmentName,
            settlementCreateDate: data.data[0]?.settlementCreateDate || formatDate(new Date()),
            settlementBusinessType: data.data[0]?.businessType || '05',
            salesmanName: data.data[0]?.salesmanName || this.userInfo.userName,
            receivableAccountPeriod: data.data[0]?.accountPeriod,
            settlementDate: data.data[0]?.periodDateUntil,
            exchangeDate: data.data[0]?.exchangeDate || formatDate(new Date()),
            printFlag: data.data[0]?.printFlag ? true : false,
            collectedAmount: data.data[0]?.collectedAmount
              ? data.data[0]?.collectedAmount + ''
              : '0',
            applyInvoiceAmount: data.data[0]?.applyInvoiceAmount
              ? data.data[0]?.collectedAmount + ''
              : '0',
          };
          console.log('获取到费用清单数据最终转换值', this.baseFormData);
          this.$nextTick(() => {
            this.$refs.baseInfoFormRef.clearValidate();
          });
          this._getInvoiceTableListData(this.baseFormData.settlementNo);
          this._getCollectTableListData(this.baseFormData.settlementNo);
        } else {
          // this.$message.error('获取数据失败');
        }
      },
      // 根据明细行数据 根据费用类型(根据expenseTypeName分类)汇总到结算行数据
      computedSettleAccountsRowByExpenseTypeName(detailList) {
        console.log(detailList);
        const expenseTypeNameMap = {};
        for (const item of detailList) {
          let mapItem = expenseTypeNameMap[item.expenseTypeName];
          if (mapItem) {
            mapItem.push(item);
          } else {
            mapItem = [item];
          }
          expenseTypeNameMap[item.expenseTypeName] = mapItem;
        }
        const formatTableList = [];
        for (const key in expenseTypeNameMap) {
          formatTableList.push({
            settlementDesc: expenseTypeNameMap[key][0].settlementDesc,
            originalPrice:
              [...new Set(expenseTypeNameMap[key].map((item) => item.unit))].length > 1
                ? ''
                : expenseTypeNameMap[key].reduce(
                    (prev, cur) => prev + (+cur.originalPrice ? cur.originalPrice : 0),
                    0
                  ),
            settlementQuantity:
              [...new Set(expenseTypeNameMap[key].map((item) => item.unit))].length > 1
                ? ''
                : expenseTypeNameMap[key].reduce(
                    (prev, cur) => prev + (+cur.settlementQuantity ? cur.settlementQuantity : 0),
                    0
                  ),
            unit:
              [...new Set(expenseTypeNameMap[key].map((item) => item.unit))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].unit,
            unitName:
              [...new Set(expenseTypeNameMap[key].map((item) => item.unitName))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].unitName,
            originalAmount: expenseTypeNameMap[key].reduce(
              (prev, cur) => prev + (+cur.originalAmount ? cur.originalAmount : 0),
              0
            ),
            businessDocCode:
              [...new Set(expenseTypeNameMap[key].map((item) => item.businessDocCode))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].businessDocCode,
            currencyCode:
              [...new Set(expenseTypeNameMap[key].map((item) => item.currencyCode))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].currencyCode,
            currencyName:
              [...new Set(expenseTypeNameMap[key].map((item) => item.currencyName))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].currencyName,
            exchangeRate:
              [...new Set(expenseTypeNameMap[key].map((item) => item.exchangeRate))].length > 1
                ? ''
                : expenseTypeNameMap[key][0].exchangeRate,
            domesticAmount: expenseTypeNameMap[key].reduce(
              (prev, cur) => prev + (+cur.domesticAmount ? cur.domesticAmount : 0),
              0
            ),
            additional: expenseTypeNameMap[key][0].additional,
            businessDocNo: expenseTypeNameMap[key][0].businessDocNo,
            remark: expenseTypeNameMap[key][0].remark,
            expenseTypeName: '监管费',
            expenseType: '01',
            // 结算明细
            lineDetails: expenseTypeNameMap[key].map((item) => {
              return {
                ...item,
                createMethod: item.createMethod == '01' ? '系统' : '手动',
              };
            }),
            // 扩展字段
            contractNo: expenseTypeNameMap[key][0].contractNo,
          });
        }
        this.settleAccountsRowList = formatTableList;
        // 单独处理如果是有结算行的时候显示明细行出来(第一行)
        if (formatTableList.length) {
          this.currentSettleAccountRowData = this.defaultSelection = formatTableList[0];
        }
      },
      computedTotalAmount(detailList) {
        const originalTotalAmount = detailList.reduce((pre, cur) => pre + +cur.originalAmount, 0);
        const domesticTotalAmount = detailList.reduce((pre, cur) => pre + +cur.domesticAmount, 0);
        const originalTotalAmountWithoutTax = detailList.reduce(
          (pre, cur) => pre + +cur.originalAmountWithoutTax,
          0
        );
        const originalTotalTaxAmount = detailList.reduce(
          (pre, cur) => pre + +cur.originalTaxAmount,
          0
        );
        const domesticTotalAmountWithoutTax = detailList.reduce(
          (pre, cur) => pre + +cur.domesticAmountWithoutTax,
          0
        );
        const domesticTotalTaxAmount = detailList.reduce(
          (pre, cur) => pre + +cur.domesticTaxAmount,
          0
        );
        console.log(originalTotalAmount, domesticTotalAmount);
        return {
          originalTotalAmount: originalTotalAmount + '' == 'NaN' ? '0' : originalTotalAmount + '',
          domesticTotalAmount: domesticTotalAmount + '' == 'NaN' ? '0' : domesticTotalAmount + '',
          originalTotalAmountWithoutTax:
            this.replaceZeroStr(originalTotalAmountWithoutTax.toFixed(2)) + '',
          originalTotalTaxAmount: this.replaceZeroStr(originalTotalTaxAmount.toFixed(2)) + '',
          domesticTotalAmountWithoutTax:
            this.replaceZeroStr(domesticTotalAmountWithoutTax.toFixed(2)) + '',
          domesticTotalTaxAmount: this.replaceZeroStr(domesticTotalTaxAmount.toFixed(2)) + '',
          unpaidAmount: domesticTotalAmount + '' == 'NaN' ? '0' : domesticTotalAmount + '',
        };
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        this.currentSettleAccountRowData = rowData;
        if (rowData) {
          // 也可能是数据反填的时候获取的数据，也有可能是手动添加的
          this.currentSettleAccountDetailList = rowData.lineDetails || [];
        }
        console.log(
          rowData,
          '获取结算行',
          this.currentSettleAccountDetailList,
          this.settleAccountsRowList
        );
      },
      // 关闭结算行汇总金额到表单中
      closeEditRowTableHandler(tableData) {
        console.log(tableData, '关闭');
        this.baseFormData = {
          ...this.baseFormData,
          // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）
          ...this.computedTotalAmount(tableData),
        };
        // 最新结算行表格数据
        this.settleAccountsRowList = tableData;
      },
      // 删除结算行数据
      deleteRowDataHandler(tableData) {
        this.settleAccountsRowList = tableData;
        console.log(this.settleAccountsRowList, '最终数据');
        // 处理结算明细中
        this.currentSettleAccountRowData = {};
        this.currentSettleAccountDetailList = [];
      },
      // 确认插入明细表数据
      confirmChooseDetailHandler(tableData) {
        console.log(tableData, '111');
        const currentRow = this.settleAccountsRowList.find(
          (item) => item._XID == this.currentSettleAccountRowData._XID
        );
        currentRow.lineDetails = tableData;
        // 根据当前结算明细中的数据汇总到结算行中
        // 1.更新编号
        currentRow.businessDocCode =
          [...new Set(currentRow.lineDetails.map((item) => item?.businessDocCode))].length > 1
            ? ''
            : currentRow.lineDetails[0]['businessDocCode'];
        // 2.结算单价
        currentRow.originalPrice =
          [...new Set(currentRow.lineDetails.map((item) => item?.originalPrice))].length > 1
            ? ''
            : currentRow.lineDetails[0]['originalPrice'];
        // 3.数量
        currentRow.settlementQuantity =
          [...new Set(currentRow.lineDetails.map((item) => item?.unit))].length > 1
            ? ''
            : currentRow.lineDetails.reduce(
                (pre, cur) => pre + (cur.settlementQuantity ? +cur.settlementQuantity : 0),
                0
              );
        // 4.原币结算金额
        currentRow.originalAmount = currentRow.lineDetails.reduce(
          (pre, cur) => pre + (cur.originalAmount ? +cur.originalAmount : 0),
          0
        );
        // 5.本币结算金额
        currentRow.domesticAmount = currentRow.lineDetails.reduce(
          (pre, cur) => pre + (cur.domesticAmount ? +cur.domesticAmount : 0),
          0
        );
        // 6.计量单位
        currentRow.unit =
          [...new Set(currentRow.lineDetails.map((item) => item?.unit))].length > 1
            ? ''
            : currentRow.lineDetails[0]['unit'];
        currentRow.unitName =
          [...new Set(currentRow.lineDetails.map((item) => item?.unitName))].length > 1
            ? ''
            : currentRow.lineDetails[0]['unitName'];
        console.log(this.settleAccountsRowList, '引入最终数据');
        // 调用结算行中的关闭表格方法(刷新表格汇总数据)
        this.$refs.settleAccountsRowTableRef.closeEditTableHandler();
      },
      // 提交审批或者保存 0 保存 1提交审批
      async saveOrSubmitHandler(type) {
        const attachments = this.$refs.fileTableRef?.getTableData();
        // 判断表单必填项
        let formRequired = false;
        this.$refs.baseInfoFormRef.validate((valid) => {
          formRequired = valid;
        });
        if (!formRequired) {
          this.$message.error('请检查基本信息填写');
          return;
        }
        // 判断结算行必填项
        let checkLinesRefStatus = await this.$refs?.settleAccountsRowTableRef?.validAllEvent();
        if (checkLinesRefStatus) {
          return;
        }
        // 1.判断是否有明细行数据
        const lineDetailsList = this.settleAccountsRowList
          .map((item) => item.lineDetails)
          .filter((item) => item);
        if (!lineDetailsList || lineDetailsList.length == 0) {
          this.$message.error('请补充明细行数据');
          return;
        }
        console.log(this.settleAccountsRowList, lineDetailsList);
        console.log('this.baseFormData.printFlag', this.baseFormData.printFlag);

        const postData = {
          type,
          ...this.baseFormData,
          // 1.自动汇总表格中的数据,避免没点击表格操作,
          // 处理汇总原币结算总金额（含税）和 本币结算总金额（含税）
          ...this.computedTotalAmount(this.settleAccountsRowList),
          businessGroup: '园区',
          lines: this.settleAccountsRowList, // 行数据
          attachments, // 附件
          settlementBusinessType: '05',
          oaId: this.userInfo.oaId,
          printFlag: this.baseFormData.printFlag && this.baseFormData.printFlag == '1' ? 1 : 0,
          id: ['create'].includes(this.$route.query?.status) ? null : this.baseFormData.id,
        };
        console.log(postData, '1111');
        this.loading.startLoading();
        const { data } = await this.$axios.post(superviseContractAPI.CREATE_OR_SUBMIT, postData);
        this.loading.endLoading();
        if (data.code == 0) {
          console.log(data);
          this.$message.success(`${type == 0 ? '保存成功' : '提交成功'}`);
          let path = {
            fromPath: {
              path: '/receivablesAndPayables/superviseContractDetail',
              name: 'superviseContractDetail',
              meta: {
                keepAlive: true,
                title: '监管单应收结算单',
              },
              query: {},
            },
            toPath: {
              path: '/receivablesAndPayables/receivablesList',
              name: 'receivablesList',
              meta: { keepAlive: true, title: '应收结算单列表' },
              query: {},
            },
          };
          this.$store.dispatch('tagsView/delView', path.fromPath).then(() => {
            this.$nextTick(() => {
              this.$router.push(path.toPath);
            });
          });
        } else {
          this.$message.error(data.msg);
        }
      },
      // 打印
      printHandler() {
        this.$refs.printDialogRef.openDialog();
      },
      // 锁定
      lockHandler() {
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(superviseContractAPI.LOCK, {
              ids: [+this.$route.query.id],
            });
            this.loading.endLoading();
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      async billingApplicationHandler() {
        if (this.baseFormData.applyInvoiceAmount >= this.baseFormData.originalAmount) {
          this.$message.error('申请开票金额 (开票申请总金额)不能大于或等于原币结算金额（含税）');
          return;
        }
        let postData = [this.$route.query?.id];
        // let postData = [28];
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.RECEIVABLE_BILLINGAPPLICATION_API}?businessGroup=${this.userInfo.businessGroup}`,
          postData
        );
        if (data.code == 0) {
          let path = {
            path: '/saleInvoice/add',
            name: 'saleInvoiceAdd',
            meta: {
              keepAlive: true,
              title: '创建销售开票',
            },
            query: { isEdit: 'Y', source: 'receive' },
            params: data.data,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          if (data.msg) {
            return this.$message.error(data.msg);
          }
          this.$message('开票申请失败');
        }
      },
      // 撤回按钮
      withdrawHandler() {
        this.$confirmAction('确定要撤回?', '撤回提示')
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(superviseContractAPI.WITHDRAW, {
              ids: [+this.$route.query.id],
              oaId: this.userInfo.oaId,
            });
            this.loading.endLoading();
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 关闭
      closeHandler() {
        this.$confirmAction('确定要关闭?', '关闭提示')
          .then(async () => {
            this.loading.startLoading();
            const { data } = await this.$axios.post(superviseContractAPI.CLOSE, {
              ids: [+this.$route.query.id],
            });
            this.loading.endLoading();
            console.log(data, '1111');
            if (data.code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.closeCurrentAndToList();
            } else {
              this.$alert(data.msg);
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      closeCurrentAndToList() {
        this.$store.dispatch('tagsView/delView', {
          path: '/receivablesAndPayables/superviseContractDetail',
          name: 'superviseContractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/receivablesAndPayables/receivablesList' });
      },
      detailPrintHandler(val) {
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
    },
    components: {
      SettleAccountsRowTable,
      SettleAccountsDetailTable,
      BillingInfoTable,
      PrintDemo,
      Print,
      PrintDialog,
      ReceiveInfoTable,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
